import { DEFAULT_CONTENT_TIME } from 'constants/appConstants'
import { createGlobalStyle } from 'styled-components'

const GlobalStyle = createGlobalStyle`
  body {
    font-family: AzoSans;
    margin: 0;
    overflow: hidden;
  }

  h1, h2, h3, h4, h5, h6, p {
    margin: 0 0 15px 0;
  }

  ul {
    list-style: none;
  }

  a {
    text-decoration: none;
    color: inherit;
  }

  img {
    width: 100%;
  }

  .kenburns-image {
    animation-name: kenburns-image;
    animation-duration: ${DEFAULT_CONTENT_TIME}ms;
    animation-fill-mode: forwards;
  }
`

export default GlobalStyle
